import React, { useState, useEffect } from 'react';
import { Col, Row, Container, Table, Form } from 'react-bootstrap';
import NavBar from '../Components/NavBar';
import SideNavbar from '../Components/SideNavbar';
import '../index.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { configureWatchAction } from '../Store/Actions/participant'
import { connect } from 'react-redux'
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify'
import AlertBox from '../Components/AlertBox'
import axios from 'axios';
import getApiUrl from '../config';
import { config } from 'aws-sdk';


function EditConfigureWatch(props) {
    const [currentSideActive, setCurrentSideActive] = useState(4)
    const [selectValue, setSelectValue] = useState("totalPar");
    const [order, setOrder] = useState("normal");
    const [campaignList, setCampaignList] = useState([])
    const [participantList, setParticipantList] = useState([])
    const [alertShow, setAlertShow] = useState([false, ""])
    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate()
    const [tempCampaignId, setTempCampaignId] = useState("")
    const [showForm, setShowForm] = useState(false)
    const [validated, setValidated] = useState(false)


    useEffect(() => {
        Auth.currentSession().then(session => {
            if (session.isValid()) {
                let role = session.getIdToken().payload["custom:role"];
                // if (role == "admin") {
                //     navigate("/managerDashboard")
                // }
                if (role == "participant") {
                    navigate("/participantDashboard")
                }
                else {
                    if (localStorage.getItem("managerId") == null) {
                        let id = session.getIdToken().payload["custom:id"];
                        localStorage.setItem("managerId", id)
                    }
                    getTheCampaignList()
                }
            }
            else {
                Auth.signOut()
                navigate("/")
            }
        }).catch(error => {
            Auth.signOut()
            navigate("/")
        })
    }, [])

    useEffect(() => async () => {


    }, [])

    const getTheCampaignList = async () => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            // 2. Add Authorization to Config
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newGetCampaignList'), {
                manager_id: localStorage.getItem("managerId"),

            }, config)
            console.log(response)
            setCampaignList(response.data.campaigns)
        }
        catch (error) {
            console.log(error)
        }
    }

    const details = {
        campaign_id: "",
        participant_id: "",
        watchid: "",
        updated_watchid: "",
        starttime: "",
        endtime: ""
    }
    const [configureDetails, setConfigureDetails] = useState(details)


    const handleChange = (e, key) => {
        if (key == "campaign_id") {
            setTempCampaignId(e.target.value)
        }

        const newObject = { ...configureDetails }
        newObject[key] = e.target.value
        setConfigureDetails(newObject)

    }

    const handleParticipantChange = async (e, campaign_id) => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            // 2. Add Authorization to Config
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newGetWatchConfig'), {
                //manager_id : localStorage.getItem("managerId"),
                campaign_id: campaign_id, //localStorage.getItem("campaignId")
                participant_id: e.target.value
            }, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
            }
            const data = response.data
            console.log("Watch config API response:", data)
            const newObject = { ...configureDetails }
            // Convert datetime strings from "YYYY-MM-DD HH:MM:SS" to "YYYY-MM-DDTHH:MM" for datetime-local input
            const formatDateTime = (dateStr) => {
                if (!dateStr) return "";
                // Replace space with 'T' and remove seconds for datetime-local format
                return dateStr.replace(" ", "T").substring(0, 16);
            }
            // Handle both possible key names: watchId or watch_id
            const watchId = data.watchid
            newObject["starttime"] = formatDateTime(data.starttime)
            newObject["endtime"] = formatDateTime(data.endtime)
            newObject["watchid"] = watchId
            newObject["updated_watchid"] = watchId
            newObject["participant_id"] = e.target.value
            newObject["campaign_id"] = campaign_id
            setConfigureDetails(newObject)
        }
        catch (error) {
            setAlertShow([true, "danger"])
            setErrorMsg(error.message)
            console.log(error)
        }

    }

    const handleSubmit = async () => {
        console.log(props)
        configureDetails.manager_id = localStorage.getItem("managerId")
        console.log("This is the configure details", configureDetails)
        handleConfigureWatch(configureDetails)
        //await props.configureWatch(configureDetails)
        //navigate("/campaignDashboard")

    }

    const handleConfigureWatch = async (configDetails) => {
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            // 2. Add Authorization to Config
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newUpdateWatchConfig'), configDetails, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
                window.scrollTo(0, 0)  // Scroll to top to show alert
            }
            else {
                console.log("SUCCESS: Setting alert to show success message")
                setAlertShow([true, "success"])
                setErrorMsg("Watch configured successfully")
                window.scrollTo(0, 0)  // Scroll to top to show alert
                // navigate("/managerDashboard")
            }
        }
        catch (err) {
            setAlertShow([true, "danger"])
            setErrorMsg(err.message)
            console.log(err)
        }
    }

    const handleCampaignChange = async (e) => {
        console.log("This campaign change")
        try {
            const session = await Auth.currentSession();
            const token = session.getIdToken().getJwtToken();

            // 2. Add Authorization to Config
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
            const response = await axios.post(getApiUrl('newGetParticipantList'), {
                manager_id: localStorage.getItem("managerId"),
                campaign_id: e.target.value //localStorage.getItem("campaignId")
            }, config)
            if (response.status !== 200) {
                setAlertShow([true, "danger"])
                setErrorMsg(response.data.error)
            }
            console.log(response)
            setParticipantList(response.data.participants)
            setShowForm(true)
        }
        catch (error) {
            setAlertShow([true, "danger"])
            setErrorMsg(error.message)
            console.log(error)
        }

    }


    return (
        <div style={{ height: "100%", overflowY: "auto" }} className="bg-image">
            <NavBar />
            <div style={{ height: "inherit" }}>
                <Container style={{ height: "100%" }}>
                    <Row style={{ height: "100%" }}>
                        <Col lg={2} style={{ height: "75%" }}>
                            <SideNavbar list={["Campaign List", "Create Campaign", "Edit Campaign", "Create Coordinator", "Coordinator Permissions", "Edit Watch Configuration"]} active={5} links={["/managerDashboard", "/createCampaign", "/editCampaign", "/createCoordinator", "/coordinatorPermission", "/editConfigureWatch"]} />
                        </Col>
                        <Col style={{ height: "75%" }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '18px',
                                fontWeight: '600',
                                marginBottom: '20px',
                                cursor: 'pointer',
                                color: '#007bff'
                            }} onClick={() => navigate("/campaignDashboard")}>
                                <FaArrowLeft style={{ marginRight: '8px' }} />
                                Back to Dashboard
                            </div>
                            {alertShow[0] && (
                                <div style={{ marginBottom: '20px' }}>
                                    <AlertBox
                                        type={alertShow[1]}
                                        message={errorMsg}
                                    />
                                </div>
                            )}
                            <h2>Edit Configure Watch</h2>
                            <hr />
                            <Container className="p-4" style={{ background: "rgba(255,255,255,0.3)", height: "50%", overflowY: "auto" }}>
                                <Col className='mt-3'>
                                    <Form.Group>
                                        <Form.Label>Select Campaign</Form.Label>
                                        <Form.Select style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "campaign_id"); handleCampaignChange(e); }}>
                                            <option value="">select option</option>
                                            {campaignList.map((data) =>
                                                (<option key={data} value={data}>{data}</option>)
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col className='mt-3'>
                                    <Form.Group>
                                        <Form.Label>Select Participant</Form.Label>
                                        <Form.Select style={{ background: "rgba(0,0,0,0.05)" }} onChange={(e) => { handleChange(e, "participant_id"); handleParticipantChange(e, configureDetails.campaign_id) }}>
                                            <option>select option</option>
                                            {participantList.map((data) => (<option key={data.participant_id} value={data.participant_id}>{data.participant_id}</option>))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Container>
                            <hr></hr>
                            {showForm && <Container className="p-4" style={{ background: "rgba(255,255,255,0.3)", height: "inherit", overflowY: "auto" }}>
                                <Form noValidate validated={validated} onSubmit={(e) => {
                                    e.preventDefault();
                                    const form = e.currentTarget;
                                    if (form.checkValidity() === false) {
                                        e.stopPropagation();
                                        setValidated(true);
                                    } else {
                                        setValidated(false);
                                        handleSubmit();
                                    }
                                }}>
                                    <Col className='mt-3'>
                                        <Form.Group controlId="watchId">
                                            <Form.Label>Enter Watch ID</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={configureDetails.updated_watchid}
                                                isInvalid={validated && !configureDetails.updated_watchid}
                                                onChange={(e) => { handleChange(e, "updated_watchid"); }}
                                                style={{ background: "rgba(0,0,0,0.05)" }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Watch ID is required.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col className='mt-3'>
                                        <Form.Group controlId="startDate">
                                            <Form.Label>Start Date</Form.Label>
                                            <Form.Control
                                                required
                                                type="datetime-local"
                                                value={configureDetails.starttime}
                                                isInvalid={validated && !configureDetails.starttime}
                                                onChange={(e) => { handleChange(e, "starttime"); }}
                                                style={{ background: "rgba(0,0,0,0.05)" }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Start date is required.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col className='mt-3'>
                                        <Form.Group controlId="endDate">
                                            <Form.Label>End Date</Form.Label>
                                            <Form.Control required type="datetime-local" value={configureDetails.endtime}
                                                isInvalid={validated && !configureDetails.endtime}
                                                onChange={(e) => { handleChange(e, "endtime"); }}
                                                style={{ background: "rgba(0,0,0,0.05)" }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                End date is required.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>


                                    <Col>
                                        <Form.Control type="submit" className='btn btn-primary mt-5' value={"Configure"} />
                                    </Col>


                                </Form>
                            </Container>}

                        </Col>
                    </Row>
                </Container>
            </div>

        </div>

    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        manager: state.manager,
        campaign: state.campaign,
        state: state.state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        configureWatch: (configuration) => dispatch(configureWatchAction(configuration))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(EditConfigureWatch);
